import React, { useContext, useMemo } from 'react';
import { ITicket } from '../../../../../../types/Ticket/ITicket';
import { useReduxDispatch, useReduxSelector } from '../../../../../../redux/hooks';
import { TicketApi } from '../../../../../../redux/api/TicketApi';
import { Button, SplitButton } from '@progress/kendo-react-buttons';
import { RevUserContext, RevUserContextType } from '../../../../../../context/UserContext';
import { IUserProfile } from '../../../../../../types/User/IUserProfile';
import { Card, CardBody, CardHeader } from '@progress/kendo-react-layout';
import * as svg from '@progress/kendo-svg-icons';
import { Link } from 'react-router-dom';
import { CardFooter } from 'react-bootstrap';
import { FileType } from '../../../../../../types/File/FileType';
import { FileApi } from '../../../../../../redux/api/FileApi';
import { nanoid } from 'nanoid';
import { useCloseTicketLogic } from '../../../../../../hooks/useCloseTicketLogic';
import EventForm from './EventForm';
import { SvgIcon } from '@progress/kendo-react-common';
import * as EventSlice from '../../../../../../slices/EventSlice';
import IEvent from '../../../../../../types/Ticket/IEvent';

interface AddActionProps {
    ticket: ITicket
    onsubmitted?: () => void
    onclosed?: () => void
    showHeader?: boolean
    showSaveButton?: boolean
    actionId?: number
    formName?: string
}

const AddEvent: React.FC<AddActionProps> = ({ actionId, ticket, onsubmitted, onclosed, showHeader, showSaveButton }) => {
    const { profile } = React.useContext<RevUserContextType>(RevUserContext)
    const { data: isFileActiveInternal } = FileApi.useIsActiveQuery(FileType.Call_Action_Internal)
    const { data: isFileActiveExternal } = FileApi.useIsActiveQuery(FileType.Call_Action_External)
    const eventDetails = useReduxSelector(state => state.eventDetails);
    const [createEvent, { isLoading: savingAction }] = TicketApi.useCreateEventMutation();
    const dispatch = useReduxDispatch();
    const [apiError, setApiError] = React.useState<string>()
    //Get existing action
    //const { data: action, isFetching: fetchingAction } = TicketApi.useGetActionQuery({ actionId: actionId, ticketId: ticket?.ID }, { skip: (!actionId || !ticket?.ID) });
    //Create a unique form name
    const formName = useMemo(() => 'new-event_' + nanoid(), [actionId]);

    const onCloseClicked = () => {
        if (eventDetails?.Notes?.length > 0 && !window.confirm('You have unsaved changes. Are you sure you want to cancel adding this Event?')) return;

        dispatch(EventSlice.resetEventForm({} as IEvent));

        onclosed();
    }


    const externalUser = profile?.Features.External_Interface;

    return (
        <div>
            <div>
                <Card className='no-pop p-0 action-form'>
                    {showHeader && <CardHeader className='action-header' style={{ color: '#fff', background: profile?.Nav_Hex_Color }}>
                        <div className='d-flex align-items-center flex-row flex-grow justify-content-between'>
                            <div><SvgIcon icon={svg.calendarIcon} /> New Event</div>
                            {/*Link goes on the far right */}
                            <div>
                                <Link className='align-items-right' to={`./event`} title='Pop out' style={{ color: '#fff' }}>
                                    <Button fillMode='flat' size='medium' svgIcon={svg.windowRestoreIcon} className='off'></Button>
                                </Link>
                                <Button fillMode='flat' size='medium' svgIcon={svg.xIcon} title='close' onClick={onCloseClicked}></Button>
                            </div>
                        </div>
                    </CardHeader>}
                    <CardBody>
                        <EventForm formName={formName} onsubmitted={onsubmitted} onclosed={onclosed} />
                    </CardBody>
                    <CardFooter>
                        <div className=''>
                            <div className='ms-auto p-1 d-flex flex-row-reverse col-12' >
                                <Button form={formName} type={"submit"} style={{ color: '#fff', background: profile?.Nav_Hex_Color }} className='save-action-button'>
                                    <img src='./images/Log-Ticket-White.png' className='inline mr-2 w-5' alt="Save Action" />
                                    Save Event
                                </Button>
                            </div>
                        </div>
                    </CardFooter>
                </Card>
            </div>

        </div>
    );
};

export default AddEvent;